<template>
  <div>
    <div class="page-footer-inner"> 2019 - {{ new Date().getFullYear() }} &copy; | <a href="https://www.alfiobardolla.com/" target="_blank">Alfio
      Bardolla Training Group</a> | v. 3.1.0
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';

export default {
  data: function () {
    return {}
  },
  computed: {
    ...mapState('n_github', ['githubTag'])
    
  },
  created() {
    //  this.githubVersion();
  },
  methods: {
    ...mapActions('n_github', ['githubVersion'])
  }
}
</script>
